import './Contact.scss';
import React from 'react';
import Button from '../../components/Button';

const ContactUs = () => {
  // return (
  //   <div className='container'>
  //     {'ContactUs'}
  //   </div>
  // )
  return (
    <div className='contact-page container'>
      {/* <div className='contact-banner'>
        <div className='container'>
          <h1>Liên hệ với chúng tôi</h1>
        </div>
      </div> */}
      <div className='contact-grid'>
        <div className='contact-left'>
          <h2>Liên hệ với chúng tôi</h2>
          <p>Quý khách hàng quan tâm sản phẩm xin vui lòng liên hệ để được hỗ trợ tốt nhất. Xin cảm ơn!</p>
          <div className='contact-col'>
            <h5>Trụ sở chính</h5>
            <p>22/5 Yên Thế, phường Tân Sơn Hòa, thành phố Hồ Chí Minh.</p>
            <p>Email:<a href="mailto:info@vietbando.vn">info@vietbando.vn</a></p>
            <p>Hotline:<a href="tel:1900996673">1900996673</a></p>
          </div>
          <h6 style={{fontWeight : 'bold', marginBottom: '1rem'}}>Nhánh 1: Hỗ trợ kinh doanh</h6>
          <h6 style={{fontWeight : 'bold', marginBottom: '1rem'}}>Nhánh 2: Hỗ trợ kỹ thuật</h6> 
        </div>
        <div className='contact-card'>
          <h5>Chi tiết liên lạc</h5>
          <form className='contact-field'>
            <input
              type="text"
              className="contact-input"
              name="name"
              placeholder="Họ tên"
            />
            <input
              type="text"
              className="contact-input"
              name="name"
              placeholder="Email"
            />
            <input
              type="text"
              className="contact-input"
              name="name"
              placeholder="Tiêu đề"
            />            
            <textarea
              name="message"
              placeholder="Chúng tôi có thể giúp gì cho bạn?"
            />
          </form>
          <Button buttonSize="vbt-larger" buttonStyle="vbt-blue-solid">Gửi tin</Button>
        </div>
      </div>     
    </div>
  )
}
export default ContactUs;